import { render, staticRenderFns } from "./ReListOfPeople.vue?vue&type=template&id=fd3a9d58&scoped=true"
import script from "./ReListOfPeople.vue?vue&type=script&lang=js"
export * from "./ReListOfPeople.vue?vue&type=script&lang=js"
import style0 from "./ReListOfPeople.vue?vue&type=style&index=0&id=fd3a9d58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd3a9d58",
  null
  
)

export default component.exports